export enum RescheduleOrderStepName {
  Initial = 'initial',
  VerifyAddress = 'verify-address',
  DoormanConfirmation = 'confirm-doorman',
}

export type RescheduleOrderPathParams = {
  orderId: string;
  stepName: RescheduleOrderStepName;
};
